var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "text-path-picker" },
    [
      _c(
        _setup.CButton,
        {
          directives: [
            {
              name: "tippy",
              rawName: "v-tippy",
              value: _setup.tooltipOptions,
              expression: "tooltipOptions",
            },
          ],
          staticClass: "text-path-btn",
          attrs: { variant: "secondary", size: "icon", title: "Arc" },
          on: {
            click: function ($event) {
              return _setup.applyPreset("arc")
            },
          },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 8",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d:
                    "M11.6575 0C13.0786 0 14.3713 0.137109 15.7136 0.667317C16.957 1.15848 18.2025 1.97089 19.62 3.25319L20.1552 2.63058L20.1778 2.6055C20.4171 2.35398 20.8144 2.33171 21.0806 2.56056L23.0357 4.24079L23.0608 4.26346C23.3042 4.49508 23.3329 4.87453 23.1271 5.14011L23.1058 5.16622L21.4255 7.12139L21.4028 7.14647C21.1712 7.38983 20.7918 7.41851 20.5262 7.21272L20.5001 7.19141L18.5449 5.5111C18.2787 5.28225 18.241 4.88629 18.4536 4.61186L18.4749 4.58566L18.7643 4.2488C17.414 3.0236 16.2931 2.30744 15.2313 1.88804C14.1004 1.4413 12.9897 1.31252 11.6575 1.31252C10.4194 1.31253 9.36277 1.42966 8.24788 1.87794C7.16153 2.31476 5.97605 3.08383 4.50458 4.44539L4.76606 4.70687L4.78929 4.73131C5.01455 4.98061 5.01455 5.36121 4.78929 5.61051L4.76606 5.63495L2.94315 7.45785L2.91864 7.48109C2.66934 7.70631 2.28889 7.70631 2.03959 7.48109L2.01508 7.45785L0.192169 5.63495C-0.0560798 5.38668 -0.0637914 4.989 0.168937 4.73139L0.192169 4.70687L2.01508 2.88397L2.03959 2.86073C2.2972 2.628 2.69488 2.63572 2.94315 2.88397L3.57594 3.51676C5.13765 2.06612 6.46713 1.17934 7.75825 0.660188C9.08743 0.125742 10.3291 3.37586e-06 11.6575 0ZM1.58432 5.17095L2.47915 6.0657L3.3739 5.17095L2.47915 4.27612L1.58432 5.17095ZM19.8981 4.94344L20.8578 5.76817L21.6826 4.80853L20.7229 3.98372L19.8981 4.94344Z",
                  fill: "black",
                },
              }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        _setup.CButton,
        {
          directives: [
            {
              name: "tippy",
              rawName: "v-tippy",
              value: _setup.tooltipOptions,
              expression: "tooltipOptions",
            },
          ],
          staticClass: "text-path-btn",
          attrs: { variant: "secondary", size: "icon", title: "Line" },
          on: {
            click: function ($event) {
              return _setup.applyPreset("line")
            },
          },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 22 10",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M19.9388 0.0213663C20.2776 -0.0668055 20.6301 0.125216 20.7367 0.462773L21.5179 2.94324L21.5277 2.97644C21.6129 3.30437 21.4352 3.64452 21.1176 3.76258L21.0863 3.77332L18.6058 4.55555L18.5726 4.56433C18.2447 4.6496 17.9046 4.4727 17.7865 4.15516L17.7758 4.12293L17.5912 3.53699L4.41638 7.71863L4.55505 8.15711L4.56482 8.18933C4.65017 8.51733 4.47235 8.85836 4.15466 8.97644L4.12244 8.98719L1.64197 9.76844L1.60974 9.7782C1.28175 9.86354 0.940714 9.68573 0.822632 9.36805L0.81189 9.33582L0.0306399 6.85535C-0.0755212 6.51767 0.10291 6.15898 0.431031 6.03699L0.463257 6.02527L2.94275 5.24402L2.97595 5.23426C3.31484 5.14615 3.66738 5.33888 3.7738 5.67664L4.01892 6.45594L17.1927 2.2743L16.9935 1.64246C16.8872 1.30471 17.0657 0.94514 17.3939 0.823124L17.4261 0.812382L19.9066 0.0311319L19.9388 0.0213663ZM1.49255 7.08973L1.87537 8.30652L3.09314 7.92273L2.70935 6.70594L1.49255 7.08973ZM18.4554 1.87586L18.8392 3.09363L20.057 2.70984L19.6732 1.49207L18.4554 1.87586Z",
                  fill: "black",
                },
              }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        _setup.CButton,
        {
          directives: [
            {
              name: "tippy",
              rawName: "v-tippy",
              value: _setup.tooltipOptions,
              expression: "tooltipOptions",
            },
          ],
          staticClass: "text-path-btn",
          attrs: { variant: "secondary", size: "icon", title: "Wave" },
          on: {
            click: function ($event) {
              return _setup.applyPreset("wave")
            },
          },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 29 8",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d:
                    "M25.895 0.188563C26.1168 -0.0445089 26.4848 -0.0651425 26.7316 0.146919L28.5432 1.70388L28.5664 1.72489C28.792 1.93951 28.8186 2.29112 28.6279 2.53721L28.6081 2.56141L27.0512 4.37314L27.0301 4.39638C26.8155 4.62188 26.4639 4.64839 26.2178 4.45769L26.1935 4.43795L25.7942 4.09469C25.5186 4.44028 25.1082 4.89531 24.5576 5.35027C23.4427 6.27154 21.7425 7.2 19.4358 7.2C18.0716 7.2 17.0757 6.86581 16.266 6.33741C15.4804 5.82474 14.895 5.14071 14.3549 4.53601C13.7998 3.91447 13.2705 3.34783 12.5476 2.9115C11.8358 2.48196 10.9022 2.15997 9.53029 2.10652C7.82902 2.04023 6.40899 2.56658 5.40599 3.11816C4.90541 3.39345 4.51353 3.67246 4.24899 3.88068C4.17171 3.94151 4.10555 3.99621 4.05087 4.04273L4.41639 4.40825L4.43792 4.43089C4.64665 4.66191 4.64665 5.01458 4.43792 5.2456L4.41639 5.26824L2.72722 6.95741L2.70451 6.97901C2.4735 7.18768 2.12095 7.18763 1.88995 6.97893L1.86723 6.95741L0.178067 5.26824C-0.0519621 5.03818 -0.0591124 4.66968 0.15654 4.43097L0.178067 4.40825L1.86723 2.71908L1.88995 2.69756C2.12866 2.4819 2.49717 2.48906 2.72722 2.71908L3.18858 3.18044C3.26712 3.11165 3.37026 3.0246 3.49679 2.92501C3.80399 2.68322 4.2512 2.36516 4.81992 2.0524C5.95552 1.4279 7.59505 0.814006 9.57765 0.891251C11.1323 0.951824 12.27 1.32346 13.176 1.87023C14.0707 2.41021 14.7054 3.10264 15.262 3.72583C15.8336 4.36584 16.3077 4.91226 16.9307 5.31887C17.5297 5.70976 18.2916 5.98377 19.4358 5.98377C21.3926 5.98377 22.828 5.20182 23.7828 4.41278C24.2614 4.01731 24.6166 3.62185 24.8506 3.32735C24.8576 3.3186 24.8643 3.30985 24.871 3.30129L24.3819 2.88099C24.1352 2.66893 24.1002 2.30202 24.2973 2.04772L24.317 2.02345L25.874 0.211724L25.895 0.188563ZM1.46809 4.83828L2.29727 5.66739L3.12637 4.83828L2.29727 4.0091L1.46809 4.83828ZM25.6358 2.35497L26.5251 3.1192L27.2894 2.22989L26.4001 1.46566L25.6358 2.35497Z",
                  fill: "black",
                },
              }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(_setup.CButton, {
        directives: [
          {
            name: "tippy",
            rawName: "v-tippy",
            value: _setup.tooltipOptions,
            expression: "tooltipOptions",
          },
        ],
        staticClass: "text-path-btn",
        class: { active: _setup.isDrawing },
        attrs: {
          variant: "secondary",
          size: "icon",
          icon: ["far", "pen-nib"],
          title: "Pen",
        },
        on: { click: _setup.togglePen },
      }),
      _vm._v(" "),
      _c(_setup.CButton, {
        directives: [
          {
            name: "tippy",
            rawName: "v-tippy",
            value: _setup.tooltipOptions,
            expression: "tooltipOptions",
          },
        ],
        staticClass: "text-path-btn",
        attrs: {
          variant: "secondary",
          size: "icon",
          title: "Import SVG",
          icon: ["far", "arrow-up-from-bracket"],
        },
        on: {
          click: function ($event) {
            _setup.showImportModal = true
          },
        },
      }),
      _vm._v(" "),
      _c(_setup.CButton, {
        directives: [
          {
            name: "tippy",
            rawName: "v-tippy",
            value: _setup.tooltipOptions,
            expression: "tooltipOptions",
          },
        ],
        staticClass: "text-path-btn",
        attrs: {
          variant: "secondary",
          size: "icon",
          disabled: !_setup.hasPath,
          icon: ["far", "arrow-right-arrow-left"],
          title: "Reverse direction",
        },
        on: { click: _setup.reversePath },
      }),
      _vm._v(" "),
      _c(_setup.CButton, {
        directives: [
          {
            name: "tippy",
            rawName: "v-tippy",
            value: _setup.tooltipOptions,
            expression: "tooltipOptions",
          },
        ],
        staticClass: "text-path-btn",
        class: { active: _setup.isEditing },
        attrs: {
          variant: "secondary",
          size: "icon",
          disabled: !_setup.hasPath,
          icon: ["fa", "pencil"],
          title: "Edit",
        },
        on: { click: _setup.toggleEditor },
      }),
      _vm._v(" "),
      _c(_setup.TextPathImportModal, {
        attrs: { "text-element": _vm.textElement },
        on: { apply: _setup.applyImportedPath },
        model: {
          value: _setup.showImportModal,
          callback: function ($$v) {
            _setup.showImportModal = $$v
          },
          expression: "showImportModal",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }